import React from 'react';
import { Trans } from 'react-i18next';
import Loading from '@jg/loading';
import { Button } from '@jg/react-tracking';
import { IGiftAidForm } from './GiftAidForm.d';
import config from '../../config';

const GiftAidForm = (
  // eslint-disable-next-line no-shadow
  { values, handleSubmit, setFieldValue, isInFlight }: IGiftAidForm, // TODO change this to a React class to avoid calling an anonymous function every time on the input radio
) => (
  <form onSubmit={handleSubmit}>
    <h2 className="jg-text--center jg-space-mbmd">
      <Trans i18nKey="content.giftaid.subheading" />
    </h2>
    <p className="jg-h5 jg-space-mtsm">
      <Trans i18nKey="content.giftaid.askfordonations" />
    </p>
    <p className="jg-text--large jg-space-mtsm jg-space-mbmd">
      <Trans i18nKey="content.giftaid.askfordonations.eg" />
    </p>
    <input
      type="radio"
      checked={!values.askingForDonation}
      id="notAskingForDonation"
      name="askingForDonation"
      className="jg-radio"
      onChange={() => {
        setFieldValue('askingForDonation', false);
      }}
    />
    <label
      className="jg-text--medium-regular jg-space-mbsm"
      htmlFor="notAskingForDonation"
    >
      <Trans i18nKey="global.no" />
    </label>
    <input
      type="radio"
      checked={values.askingForDonation}
      id="askingForDonation"
      name="askingForDonation"
      className="jg-radio"
      onChange={() => {
        setFieldValue('askingForDonation', true);
      }}
    />
    <label className="jg-text--medium-regular" htmlFor="askingForDonation">
      <Trans i18nKey="global.yes" />
    </label>
    <p className="jg-h5 jg-space-mtml">
      <Trans i18nKey="content.giftaid.contributingtocost" />
    </p>
    <p className="jg-text--large jg-space-mtsm jg-space-mbmd">
      <Trans i18nKey="content.giftaid.contributingtocost.eg" />
    </p>
    <input
      type="radio"
      checked={!values.contributingToCost}
      id="notcontributingToCost"
      name="contributingToCost"
      className="jg-radio"
      onChange={() => {
        setFieldValue('contributingToCost', false);
      }}
    />
    <label
      className="jg-text--medium-regular jg-space-mbsm"
      htmlFor="notcontributingToCost"
    >
      <Trans i18nKey="global.no" />
    </label>
    <input
      type="radio"
      checked={values.contributingToCost}
      id="contributingToCost"
      name="contributingToCost"
      className="jg-radio"
      onChange={() => {
        setFieldValue('contributingToCost', true);
      }}
    />
    <label
      className="jg-text--medium-regular jg-space-mbml"
      htmlFor="contributingToCost"
    >
      <Trans i18nKey="global.yes" />
    </label>
    <input
      type="checkbox"
      id="agreePolicies"
      name="agreePolicies"
      className="jg-checkbox"
      onChange={() => {
        setFieldValue('agreePolicies', !values.agreePolicies);
      }}
    />
    <label
      className="jg-text--medium-regular jg-space-mbms"
      htmlFor="agreePolicies"
    >
      <Trans i18nKey="content.giftaid.agreePolicies">
        <a
          href="https://www.justgiving.com/info/terms-of-service/"
          target="_blank"
          rel="noopener noreferrer"
        >
          JustGiving Terms of Service
        </a>
        <a
          href="https://www.justgiving.com/info/privacy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
      </Trans>
    </label>
    <input
      type="checkbox"
      id="readGuidanceNote"
      name="readGuidanceNote"
      className="jg-checkbox"
      onChange={() => {
        setFieldValue('readGuidanceNote', !values.readGuidanceNote);
      }}
    />
    <label
      className="jg-text--medium-regular jg-space-pvn"
      htmlFor="readGuidanceNote"
    >
      <Trans i18nKey="content.giftaid.readGuidanceNote">
        <a
          href="https://www.fundraisingregulator.org.uk/more-from-us/resources/online-fundraising-advice-and-guidance-public"
          target="_blank"
          rel="noopener noreferrer"
        >
          Fundraising Regulator’s Guidance Notes
        </a>
      </Trans>
    </label>
    <img
      className="jg-space-mvml"
      src={`${config.publicPath}public/registered-fundrasing-regulator.svg`}
      alt="fundraising regulator logo"
      width="150"
      height="47"
    />
    <div className="jg-tc-button-container">
      <Button
        type="submit"
        id="jg-tc-create-team-continue-button"
        data-qa="gift-aid-continue-button"
        className="jg-btn jg-space-mbxl jg-space-mtxs"
        disabled={
          !values.agreePolicies || !values.readGuidanceNote || isInFlight
        }
        trackingData={{
          action_name: 'click',
          subtype: 'button',
          event: 'click',
          event_value: 'join the team',
          page_section: 'join team > fundraising page creation > gift aid',
        }}
      >
        {isInFlight ? (
          <Loading size="small" colour="purple" />
        ) : (
          <Trans i18nKey="global.button.createyourpage">Create your page</Trans>
        )}
      </Button>
    </div>
  </form>
);

export default GiftAidForm;
